
// Create and Update Form
import {Button, DatePicker, Drawer, Form, Input, notification, Select} from "antd";
import React, {Component} from "react";
import {FormType} from "~/src/utils/form";
import ManagementHelperApi from "~/src/api-client/api/ManagementHelperApi";
import moment from "moment";

@Form.create()
class CUForm extends Component {
    static defaultProps = {
        formType: FormType.create,
        org: {id: -1, name: ''},
        data: {
            username: '',
            name: '',
            haveShopper: false,
            shopperId: null,
        }
    };

    state = {
        haveShopper: false,
    }

    create = (data) => {
        // Create waste record
        new ManagementHelperApi().managementHelperCreateWasteRecord(data).then(() => {
            if (this.props.onSuccess) {
                this.props.onSuccess()
            }
            notification.success({message: `${data.date} was successfully created`})
        }).catch((err) => {
            notification.warning({message: `Cannot create ${data.date}`, description: `${err}`, duration: 0});
        })
    };

    modify = (data) => {
        // Update waste record
        new ManagementHelperApi().managementHelperUpdateWasteRecord(this.props.data.id, data).then(() => {
            if (this.props.onSuccess) {
                this.props.onSuccess()
            }
            notification.success({message: `${data.date} was successfully modified`})
        }).catch((err) => {
            notification.warning({
                message: `Cannot modify  ${this.props.data.date}`,
                description: `${err}`,
                duration: 0
            });
        });
    };

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (err) {
                return;
            }

            values.date = moment(values.date).utc().toISOString();
            console.log('Received values of form: ', values);
            this[this.props.formType](values)
        });
    }

    render() {
        const {orgUsers} = this.props;
        const {getFieldDecorator} = this.props.form;
        const {userId, paper, plastic, metal, waste, date} = this.props.data;

        return <Drawer
            title={this.props.title}
            onClose={this.props.onClose}
            visible={this.props.isOpen}
        >
            <Form layout="vertical" onSubmit={this.handleSubmit}>
                <Form.Item label="Date" colon={false}>
                    {getFieldDecorator('date', {
                        rules: [{required: true}], initialValue: moment(date),
                    })(
                        <DatePicker />
                    )}
                </Form.Item>
                <Form.Item label="Class" hasFeedback colon={false}>
                    {getFieldDecorator('userId', {rules: [{required: true}], initialValue: userId})(
                        <Select>
                            {
                                orgUsers.map((v, i)=>{
                                    return <Select.Option key={i} value={v.id}>{v.name}</Select.Option>
                                })
                            }
                        </Select>
                    )}
                </Form.Item>
                <Form.Item label="Paper (kg)" hasFeedback colon={false}>
                    {getFieldDecorator('paper', {
                        rules: [{required: true}], initialValue: paper, normalize: (value) =>{return parseFloat(value)}
                    })(
                        <Input type="number"/>
                    )}
                </Form.Item>
                <Form.Item label="Plastic (kg)" hasFeedback colon={false}>
                    {getFieldDecorator('plastic', {
                        rules: [{required: true}], initialValue: plastic, normalize: (value) =>{return parseFloat(value)}
                    })(
                        <Input type="number"/>
                    )}
                </Form.Item>
                <Form.Item label="Metal (kg)" hasFeedback colon={false}>
                    {getFieldDecorator('metal', {
                        rules: [{required: true}], initialValue: metal, normalize: (value) =>{return parseFloat(value)}
                    })(
                        <Input type="number"/>
                    )}
                </Form.Item>
                <Form.Item label="Waste (kg)" hasFeedback colon={false}>
                    {getFieldDecorator('waste', {
                        rules: [{required: true}], initialValue: waste, normalize: (value) =>{return parseFloat(value)}
                    })(
                        <Input type="number"/>
                    )}
                </Form.Item>
                <Form.Item>
                    <Button type="primary" htmlType="submit">Submit</Button>
                </Form.Item>
            </Form>
        </Drawer>
    }
}

export default CUForm;